import React from 'react';
import PropTypes from 'prop-types';

const TitleMain = props => (
  <section className="module-title">
    <h2>
    	{"Historial de solicitudes"}
    </h2>
  </section>
);

export default TitleMain;



// WEBPACK FOOTER //
// ./source/client/components/flows_history/title.jsx